<template>
    <empty-table-message v-if="isEmpty" />
    <b-table
        v-else
        :data="evento"
        class="data-table table-overflow"
        @sort="sortTable"
        backend-sorting
        striped
    >
        <b-table-column
            v-for="(f, i) in fields"
            :key="i"
            :field="f.key"
            :label="f.key != 'atraso' ? $t(f.key) || '---' : ''"
            :width="f.width"
            :sortable="f.sortable"
            :visible="f.visible"
            v-slot="props"
            :header-class="f.key == 'label' && !isMobile() ? 'remove-space' : ''"
            :cell-class="f.cellClass"
        >
            <div v-if="f.key == 'label'">
                <div
                    class="bar"
                    :class="[
                        props.row.colaborador_aberto_qtd == 0 ? 'bar-finalizada' : 'bar-aberta',
                    ]"
                    v-tippy
                    :title="$t(props.row.colaborador_aberto_qtd == 0 ? 'finalizada' : 'aberta')"
                />
            </div>
            <template v-else-if="f.key == 'tipo'">
                <span
                    class="icon mt-2"
                    :style="{
                        color:
                            isNull(props.row.crmAgenda.tipoAgendaAtividade.cor) ||
                            !props.row.crmAgenda.tipoAgendaAtividade.cor.startsWith('#')
                                ? 'silver'
                                : props.row.crmAgenda.tipoAgendaAtividade.cor,
                    }"
                    :title="props.row.crmAgenda.tipoAgendaAtividade.descricao"
                    v-if="!isLoading"
                >
                    <i
                        class="fa-lg"
                        :class="
                            !isNull(props.row.crmAgenda.tipoAgendaAtividade.icone)
                                ? props.row.crmAgenda.tipoAgendaAtividade.icone.toLowerCase()
                                : 'fas fa-calendar'
                        "
                    />
                </span>
            </template>

            <template v-else-if="f.key == 'titulo'">
                <a
                    v-if="cameFrom == 'route'"
                    @click="
                        $emit('showModalAgendaManage', true);
                        $emit('uuidAgendaManage', props.row.uuid);
                    "
                >
                    {{ props.row.crmAgenda.titulo }}
                </a>
                <a v-else @click="$emit('edit', props.row.uuid)">
                    {{ props.row.crmAgenda.titulo }}
                </a>
            </template>
            <template v-else-if="f.key == 'cliente'">
                <span v-if="props.row.crmAgenda.cliente != undefined">
                    {{ props.row.crmAgenda.cliente.nome }}
                </span>
                <span v-else>---</span>
            </template>
            <template v-else-if="f.key == 'agendado-para'">
                {{ $moment(props.row.data_hora_inicio).format('L') }}
                <br />
                {{ $moment(props.row.data_hora_inicio).format('LT') }}
                {{ $t('as') }}
                {{ $moment(props.row.data_hora_fim).format('LT') }}
            </template>
            <template v-else-if="f.key == 'atraso'">
                <b-icon
                    :icon="props.row.atraso ? 'alert-outline' : 'clock-outline'"
                    :title="$t(props.row.atraso ? 'contem-atraso' : 'no-tempo')"
                />
            </template>
            <div
                v-else-if="
                    f.key == 'colaboradores' && props.row.crmAssAgendaEventoUsuarioList.length == 0
                "
                class="light-gray-color"
            >
                ---
            </div>
            <template
                v-else-if="
                    f.key == 'colaboradores' && props.row.crmAssAgendaEventoUsuarioList.length < 3
                "
            >
                <div
                    class="sovis-tag"
                    v-for="colaborador in props.row.crmAssAgendaEventoUsuarioList"
                    :key="colaborador.id"
                    :class="colaborador.executado ? 'is-success' : 'is-danger'"
                    :title="$t(colaborador.executado ? 'finalizado' : 'aberto')"
                    @click="callShowModal(props.row.uuid, props.row.crmAgenda.titulo)"
                >
                    <b-icon icon="eye" size="is-small" />
                    {{ colaborador.nome }}
                </div>
            </template>

            <template
                v-else-if="
                    f.key == 'colaboradores' && props.row.crmAssAgendaEventoUsuarioList.length > 2
                "
            >
                <div
                    class="sovis-container-user"
                    @click="callShowModal(props.row.uuid, props.row.crmAgenda.titulo)"
                >
                    <b-icon icon="eye" type="is-primary" class="mr-2" />
                    <div
                        v-if="props.row.colaborador_executado_qtd > 0"
                        class="qtd-users is-success"
                        :title="$t('finalizado')"
                    >
                        {{ props.row.colaborador_executado_qtd }}
                    </div>
                    <span
                        v-if="
                            props.row.colaborador_executado_qtd > 0 &&
                            props.row.colaborador_aberto_qtd > 0
                        "
                    >
                        •
                    </span>
                    <div
                        v-if="props.row.colaborador_aberto_qtd > 0"
                        class="qtd-users is-danger"
                        :title="$t('aberto')"
                    >
                        {{ props.row.colaborador_aberto_qtd }}
                    </div>
                </div>
            </template>
            <template v-else-if="f.key == 'acao'">
                <b-button
                    v-if="
                        props.row.iCanChange &&
                        (props.row.colaborador_executado_qtd == 0 ||
                            props.row.crmAssAgendaEventoUsuarioList.length == 0)
                    "
                    type="is-danger"
                    icon-right="delete"
                    @click="modalForDelete(props.row)"
                    v-tippy
                    :title="$t('excluir')"
                />
                <div v-else class="has-text-centered light-gray-color">---</div>
            </template>
            <template v-else>
                {{ props.row[f.key] }}
            </template>
        </b-table-column>
    </b-table>
</template>
<script>
export default {
    name: 'AgendaListTable',
    props: {
        evento: {
            type: Array,
            default: (_) => [],
        },
        modalForDelete: {
            type: Function,
            default: () => {},
        },
        callShowModal: {
            type: Function,
            default: () => {},
        },
        isMobile: {
            type: Function,
            default: () => {},
        },
        sortTable: {
            type: Function,
            default: () => {},
        },
        isEmpty: {
            type: Boolean,
            default: true,
        },
        isLoading: {
            type: Boolean,
            default: true,
        },
        cameFrom: {
            type: String,
            default: 'route',
        },
    },
    data() {
        return {
            fields: [
                {
                    key: 'label',
                    width: 5,
                    sortable: false,
                    visible: true,
                    cellClass: 'table-td-relative',
                },
                { key: 'tipo', width: 40, sortable: true, visible: true, cellClass: null },
                { key: 'titulo', width: null, sortable: true, visible: true, cellClass: null },
                {
                    key: 'agendado-para',
                    width: 160,
                    sortable: true,
                    visible: true,
                    cellClass: null,
                },
                { key: 'cliente', width: null, sortable: false, visible: true, cellClass: null },
                { key: 'atraso', width: 25, sortable: false, visible: true, cellClass: null },
                {
                    key: 'colaboradores',
                    width: '25%',
                    sortable: false,
                    visible: true,
                    cellClass: null,
                },
                { key: 'acao', width: 60, sortable: false, visible: true, cellClass: null },
            ],
        };
    },
};
</script>
<style lang="scss">
@media screen and (min-width: 760px) {
    .table-overflow {
        .table {
            min-width: 990px;
            .remove-space {
                padding-left: 0;
                margin-left: 0;
                padding-right: 0;
                margin-right: 0;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
// Barra de filtro
.bar {
    position: absolute;
    top: 5px;
    bottom: 5px;
    left: 5px;
    right: 5px;
    border-radius: 100px;
    width: 5px;
    min-height: 25px;
    &.bar-finalizada {
        background-color: #84bd42;
    }
    &.bar-aberta {
        background-color: #fd5858;
    }
}
.sovis-tag {
    display: inline-block;
    text-transform: capitalize;
    text-align: center;
    font-size: 11px;
    padding: 3px 5px;
    border-radius: 4px;
    color: #fff;
    margin: 1px;
    cursor: pointer;

    &.is-success {
        background-color: $green-alert;
    }
    &.is-danger {
        background-color: $orange;
    }
}
.sovis-container-user {
    cursor: pointer;
    padding: 2px 10px;
    border: solid 1px $primary-color;
    background-color: #f0f0f0;
    border-radius: 6px;
    display: flex;
    position: absolute;
    @media screen and (max-width: 850px) {
        position: relative;
    }
    .qtd-users {
        font-weight: bolder;
        font-size: 18px;
        margin: 0 10px;
        &.is-success {
            color: $green-alert;
        }
        &.is-danger {
            color: $orange;
        }
    }
}
</style>
